// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"4a006576","455":"0f57534b"}[chunkId] + ".chunk.js";
};